import React, { Component } from "react";
import PropTypes from "prop-types";
import { defineMessages } from "react-intl";

import { RegisterVipAccess, LoginLoading } from "@onelogin/react-components";
import getMfaApi from "../../../../api/mfaService";

const messages = defineMessages({
  invalidCode: "Invalid code",
  registrationTimedout: "Registration context timed out"
});

class RegisterVip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };

    this.mfaService = getMfaApi(
      this.props.trackingId,
      this.props.defaultLanguage
    );
    this.registrationId = undefined;
  }

  componentDidMount = () => {
    this.initRegistration();
  };

  initRegistration = () => {
    this.mfaService
      .initRegistration(this.props.mfaApiToken, this.props.factorId)
      .then(({ id }) => {
        this.registrationId = id;
        this.setState({
          loading: false
        });
      })
      .catch(err => err.response.json().then(this.props.onError));
  };

  onSubmitOtp = otp => {
    this.setState({
      loading: true
    });

    const { mfaApiToken } = this.props;
    //TODO: I am not sure if this is a good place to do OTP content conversion
    const normalizedOtp = {
      tokenId: otp.credentialId,
      otp1: otp.otp1,
      otp2: otp.otp2
    };
    this.mfaService
      .submitRegistrationOtp(mfaApiToken, this.registrationId, normalizedOtp)
      .then(() =>
        this.mfaService.getRegistration(mfaApiToken, this.registrationId)
      )
      .then(body => {
        switch (body.status) {
          case "accepted":
            this.props.onSuccess();
            break;
          case "rejected":
            this.props.onError();
            break;
          default:
            this.props.onError(messages.invalidCode);
            this.setState({
              loading: false
            });
        }
      })
      .catch(err => err.response.json().then(this.handleRegistrationError));
  };

  handleRegistrationError = err => {
    if (err && err.code === 404) {
      this.props.onError(messages.registrationTimedout);
    } else {
      this.props.onError(err);
    }
  };

  render = () => {
    if (this.state.loading) {
      return <LoginLoading />;
    }

    return <RegisterVipAccess onSubmit={this.onSubmitOtp} />;
  };
}

RegisterVip.propTypes = {
  mfaApiToken: PropTypes.string.isRequired,
  factorId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  trackingId: PropTypes.string.isRequired
};

export default RegisterVip;
